<template>
    <div>
        <template v-for="section in sections">
            <h5  class="mt-4" v-if="section.section_name">{{ section.section_name }}</h5>
            <div class="mt-4" v-else></div>
            <div class="row" v-for="field in section.fields">
                <div class="col-md-6">
                    <div class="row mb-1">
                        <div class="col-md-4 col-sm-12 text-muted">{{ field.label }}:</div>
                        <div class="col-md-8 col-sm-12">
                            <template v-if="field.name == 'Textarea'">
                                <div v-html="field.value"></div>
                            </template>
                            <template v-else-if="field.name == 'Employee'">
                                <template v-if="field.value != null">
                                    <router-link :to="`/employees/view/${field.value.EmployeeId}`" title="View Employee">{{ field.value.EmployeeNumber }} - {{ field.value.FirstName }} {{ field.value.LastName }}</router-link>
                                </template>
                            </template>
                            <template v-else-if="field.name == 'Equipment'">
                                <template v-if="field.value != null">
                                    <router-link :to="`/equipment/view/${field.value.equipment_id}`" title="View Equipment">{{ field.value.equipment_type_name }} - {{ field.value.serial_number }}</router-link>
                                </template>
                            </template>
                            <template v-else-if="field.name == 'Jobsite'">
                                <template v-if="field.value != null">
                                    <router-link :to="`/jobsites/view/${field.value.JobsiteId}`" title="View Jobsite">{{ field.value.JobsiteNumber }} - {{ field.value.JobsiteName }}</router-link>
                                </template>
                            </template>
                            <template v-else-if="field.name == 'User'">
                                <template v-if="field.value != null">
                                    <router-link :to="`/users/view/${field.value.UserId}`" title="View User">{{ field.value.FirstName }} {{ field.value.LastName }}</router-link>
                                </template>
                            </template>
                            <template v-else-if="field.name == 'File'">
                                <template v-if="field.value != null">
                                    <a :href="`/files/download/${field.value.file_id}`" v-if="downloadOnly(field.value.file_extension)" target="_blank" title="Download File in a New Tab">{{ field.value.file_name }}</a>
                                    <a :href="`/files/view/${field.value.file_id}`" v-else target="_blank" title="View File in a New Tab">{{ field.value.file_name }}</a>
                                </template>
                            </template>
                            <template v-else-if="Array.isArray(field.value)" v-for="(val, key) in field.value">
                                <span v-if="key > 0">, </span>{{ val }}
                            </template>
                            <template v-else>{{ field.value }}</template>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            sections: {
                type: Array,
                required: true,
            },

            baseSection: {
                type: String,
                default: null,
            },

            labelSize: {
                type: String,
                default: 'col-md-3 col-12 text-md-right text-muted'
            },

            fieldSize: {
                type: String,
                default: 'col-md-9 col-12',
            },

            pdfView: {
                type: Boolean,
                default: false,
            }
        },

        data: function() {
            return {

            }
        },


        methods: {
            downloadOnly(ext){
                //SEnd it
                return this.$root.filesDownloadOnly.indexOf(ext) === -1 ? false : true;
            },
        },

        mounted() {

        }
    }
</script>